import {
  Card,
  CardActions,
  CardContent,
  Collapse,
  createStyles,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { FiberManualRecord, ExpandMore, ExpandLess, Info } from '@material-ui/icons';
import { TimelineSeparator, TimelineItem, TimelineContent, TimelineConnector, Timeline } from '@material-ui/lab';
import { ParticipanteResponse } from 'common/genericTypes';
import { MdSpace, SmSpace, TextButton } from 'm2m.components';
import moment, { Moment } from 'moment';
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import ReactJson from 'react-json-view';

const useStyles = makeStyles(() =>
  createStyles({
    timelineItem: {
      '&:before': {
        display: 'none',
      },
    },
    timelineContent: {
      padding: '0px 16px',
    },
  })
);

interface Props {
  participante: ParticipanteResponse;
}

interface Kyc {
  id: string;
  data: Moment;
  status: string;
  transaction: object;
}

const ConsultaCaf: React.FC<Props> = (props) => {
  const { participante } = props;

  const classes = useStyles();

  const [historico, setHistorico] = useState<Array<Kyc>>([]);
  const [expanded, setExpanded] = useState<string>('');

  useEffect(() => {
    const kycResults = participante.registro.registroHistoricos?.filter((rh) => !!rh.kyc).map((rh) => rh.kyc!) ?? [];
    const kycs = kycResults.map((kyc) => {
      const resume = JSON.parse(kyc.resume);
      const transaction = JSON.parse(kyc.transaction);
      return { id: kyc.id, data: kyc.createdAt, status: resume.Status ?? '', transaction } as Kyc;
    });
    setHistorico(kycs);
  }, [participante]);

  const handleToggleMoreDetails = (key: string) => setExpanded(expanded === key ? '' : key);

  return (
    <>
      <Timeline>
        {!!historico.length &&
          historico.map(({ id, data, status, transaction }) => (
            <React.Fragment key={id}>
              <TimelineItem className={classes.timelineItem}>
                <TimelineSeparator>
                  <FiberManualRecord style={{ margin: 2 }} fontSize="small" color="primary" />
                  <TimelineConnector style={{ width: 1, backgroundColor: '#E5E5E5' }} />
                </TimelineSeparator>
                <TimelineContent className={classes.timelineContent}>
                  <Typography variant="body2">
                    {`${moment(data).format('DD/MM/YYYY')} às ${moment(data).format('HH:mm')}`}
                  </Typography>
                </TimelineContent>
              </TimelineItem>
              <TimelineItem className={classes.timelineItem}>
                <TimelineSeparator>
                  <TimelineConnector style={{ width: 1, backgroundColor: '#E5E5E5' }} />
                  <Info />
                  <TimelineConnector style={{ width: 1, backgroundColor: '#E5E5E5' }} />
                </TimelineSeparator>
                <TimelineContent className={classes.timelineContent}>
                  <Card variant="outlined" style={{ maxWidth: '50%', margin: '10px 0' }}>
                    <CardContent style={{ paddingBottom: 16 }}>
                      <Typography variant="body2" display={'inline'}>
                        {'Status: '}
                      </Typography>
                      &nbsp;
                      <Typography display={'inline'}>{status}</Typography>&nbsp;
                    </CardContent>
                    <>
                      <Collapse in={expanded === id} timeout="auto" unmountOnExit>
                        <CardContent style={{ paddingTop: 0 }}>
                          <Divider />
                          <SmSpace />
                          <ReactJson src={transaction} collapsed={3} name={'transaction'} />
                          <MdSpace />
                        </CardContent>
                      </Collapse>
                      <CardActions style={{ padding: 10, display: 'flex', justifyContent: 'flex-end' }}>
                        <TextButton
                          aria-expanded={expanded === id}
                          size="small"
                          onClick={() => handleToggleMoreDetails(id)}
                          endIcon={expanded === id ? <ExpandLess /> : <ExpandMore />}
                        >
                          {expanded === id ? 'Menos Informações' : 'Mais Informações'}
                        </TextButton>
                      </CardActions>
                    </>
                  </Card>
                </TimelineContent>
              </TimelineItem>
            </React.Fragment>
          ))}
      </Timeline>
    </>
  );
};

export default ConsultaCaf;
